import { FormField, Input } from '@playerbase/ui';
import {
  BINARY_FALSE_LABEL_DEFAULT,
  BINARY_LABEL_MAX,
  BINARY_TRUE_LABEL_DEFAULT,
} from '@playerbase/types';

interface BinaryConfigProps {
  trueLabel: string | undefined;
  falseLabel: string | undefined;
  onChange: (which: 'true' | 'false', value: string | undefined) => void;
}

const FIELD_LABEL_CLASS =
  'font-mono text-[10px] font-semibold uppercase tracking-wider text-text-muted';

// Binary defaults to Yes / No. The studio can override either side with
// custom text or an emoji - the bot stores the literal label as the
// answer, so old submissions keep their wording even if the labels
// change later.
export function BinaryConfig({
  trueLabel,
  falseLabel,
  onChange,
}: BinaryConfigProps): JSX.Element {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs text-text-muted">
        Players choose one of two options. Defaults are{' '}
        <strong className="text-text">{BINARY_TRUE_LABEL_DEFAULT}</strong> /{' '}
        <strong className="text-text">{BINARY_FALSE_LABEL_DEFAULT}</strong>;
        leave blank to use them.
      </p>

      <FormField>
        <FormField.Label className={FIELD_LABEL_CLASS}>Yes label</FormField.Label>
        <FormField.Control>
          <Input
            value={trueLabel ?? ''}
            onChange={(e) => {
              const next = e.target.value;
              onChange('true', next.length === 0 ? undefined : next);
            }}
            maxLength={BINARY_LABEL_MAX}
            placeholder={BINARY_TRUE_LABEL_DEFAULT}
            aria-label="Affirmative option label"
          />
        </FormField.Control>
      </FormField>

      <FormField>
        <FormField.Label className={FIELD_LABEL_CLASS}>No label</FormField.Label>
        <FormField.Control>
          <Input
            value={falseLabel ?? ''}
            onChange={(e) => {
              const next = e.target.value;
              onChange('false', next.length === 0 ? undefined : next);
            }}
            maxLength={BINARY_LABEL_MAX}
            placeholder={BINARY_FALSE_LABEL_DEFAULT}
            aria-label="Negative option label"
          />
        </FormField.Control>
      </FormField>
    </div>
  );
}
